export const shouldPublishSegments = (publishedIn?: number[]) =>
    publishedIn !== undefined && publishedIn.length > 0
